module.exports = __webpack_public_path__ + "img/aiot_bg3.bf4b6d57.png";